import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class ThemeHandlerService {
	/** Subject to emit which theme is currently active */
	private lightThemeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	public get isLightTheme$(): Observable<boolean> {
		return this.lightThemeSubject.asObservable();
	}

	constructor(
		@Inject(DOCUMENT) private document: Document,
		private router: Router
	) {
		this.router.events
			.pipe(
				filter(e => e instanceof NavigationEnd),
				map(e => e as NavigationEnd),
				take(1)
			)
			.subscribe(e => {
				const currentPage = e.url.split(/[/?]+/)[1];
				if (currentPage === 'self-registration-setup' || currentPage === 'sh-demo') {
					this.setTheme('light');
				} else {
					window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
						this.updateTheme();
					});
					this.updateTheme();
				}
			});
	}

	/**
	 * Determine which theme to use (dark or light)
	 */
	public updateTheme() {
		if (localStorage.getItem('THEME_') === 'sys-pref' || !localStorage.getItem('THEME_')) {
			if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
				this.setTheme('dark');
			} else {
				this.setTheme('light');
			}
		} else {
			this.setTheme(localStorage.getItem('THEME_'));
		}
	}

	/**
	 * Set the theme on the document body and emit the change to components
	 */
	private setTheme(theme: string) {
		this.document.body.className = theme;
		this.lightThemeSubject.next(theme === 'light');
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
